import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { h as handleDismiss } from './index2.js';
import { g as getAlertOrBannerIcon } from './alert-banner-icon.js';
import { d as defineCustomElement$5 } from './close-button.js';
import { d as defineCustomElement$4 } from './icon.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const alertCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;border:none;border-radius:.375rem;box-sizing:border-box;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem;min-height:40px;padding:.75rem 1rem;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.content{align-items:flex-start;display:inline-flex;gap:.75rem;width:100%}.content wui-icon{margin:.125rem 0}:host([type=info]){background-color:var(--jw-theme-info-muted-message-bg-color);color:var(--jw-theme-info-muted-message-color)}:host([type=info]) ::slotted(a),:host([type=info]) ::slotted(a:hover){--color:var(--jw-theme-info-muted-message-color)!important;color:var(--color)!important}:host([type=error]){background-color:var(--jw-theme-error-muted-message-bg-color);color:var(--jw-theme-error-muted-message-color)}:host([type=error]) ::slotted(a),:host([type=error]) ::slotted(a:hover){--color:var(--jw-theme-error-muted-message-color)!important;color:var(--color)!important}:host([type=warning]){background-color:var(--jw-theme-warning-muted-message-bg-color);color:var(--jw-theme-warning-muted-message-color)}:host([type=warning]) ::slotted(a),:host([type=warning]) ::slotted(a:hover){--color:var(--jw-theme-warning-muted-message-color)!important;color:var(--color)!important}:host([type=success]){background-color:var(--jw-theme-success-muted-message-bg-color);color:var(--jw-theme-success-muted-message-color)}:host([type=success]) ::slotted(a),:host([type=success]) ::slotted(a:hover){--color:var(--jw-theme-success-muted-message-color)!important;color:var(--color)!important}:host([type=promo]){background-color:var(--jw-theme-promo-bg-color);border-bottom:2px solid var(--jw-theme-promo-border-color);color:var(--jw-theme-promo-text-color)}:host([type=promo]) ::slotted(a),:host([type=promo]) ::slotted(a:hover){--color:var(--jw-theme-promo-text-color)!important;color:var(--color)!important}:host([type=promo]) hr{background-color:var(--jw-theme-surface-muted-message-divider)}:host([type=promo]) .content{gap:.5rem}:host([type=promo]) h5{min-width:fit-content}h5{color:var(--jw-theme-promo-label-color);margin:0;padding:0}.actions{align-items:center;display:flex;gap:.75rem;justify-content:center}.actions hr{background-color:var(--jw-theme-surface-muted-message-divider);border:none;height:24px;width:1px}";
const WuiAlertStyle0 = alertCss;

const WuiAlert$1 = /*@__PURE__*/ proxyCustomElement(class WuiAlert extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dismiss = createEvent(this, "dismiss", 3);
        this.handleDismiss = () => handleDismiss(this);
        this.dismissible = true;
        this.type = 'info';
        this.promoLabel = 'NEW! 🎉';
    }
    render() {
        const icon = getAlertOrBannerIcon(this.type);
        return (h(Host, { key: '446318d7f10b3b13b43b13e3cba5e28632e91c50' }, h("div", { key: '66bbab2a3c523ab8fb029a4770046f25565fc2c3', class: "content" }, this.type === 'promo' ? h("h5", null, this.promoLabel) : icon ? h("wui-icon", { size: "md", name: icon }) : undefined, h("div", { key: '3116f282d32e2eae2fb4d50fc9d15110c2f505ce' }, h("slot", { key: 'f70938f1889ed60de1aec34becd42e7537bf1134' }))), this.dismissible && (h("div", { key: '0d4be4d094b6bc0e85c0cd725e917c4c3288b92e', class: "actions" }, h("hr", { key: '8a155a9a5e3cc7bb41dbb51517032e7c932948fe' }), h("wui-close-button", { key: '169ff1bc17d4a7bec6f491f6d94b3f35e99a4822', onClick: this.handleDismiss, type: this.type === 'promo' ? 'bold' : 'muted' })))));
    }
    get el() { return this; }
    static get style() { return WuiAlertStyle0; }
}, [1, "wui-alert", {
        "dismissible": [4],
        "type": [513],
        "promoLabel": [1, "promo-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-alert", "wui-close-button", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-alert":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiAlert$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiAlert = WuiAlert$1;
const defineCustomElement = defineCustomElement$1;

export { WuiAlert, defineCustomElement };

//# sourceMappingURL=wui-alert.js.map